export const translations = {
    es: {
        // Títulos
        "preview.title": "Grupo de perfiles",
        "preview.title.sensor": "Configuración sensor",
        "preview.add": "Añadir",
        "preview.add.ship": "Añadir nuevo modo",
        "preview.saved": "Guardado",
        "preview.saved.success": "Se ha guardado correctamente.",
        "preview.error": "Error en el servicio",
        "preview.error.admin": "Avisar al administrador",

        // Pestañas
        "tab.data": "Datos",
        "tab.general": "General",
        "tab.sensors": "Sensores",
        "tab.alerts": "Alertas",
        "tab.shipping": "Envíos",

        // Campos
        "field.name": "Nombre",
        "field.description": "Descripción",
        "field.select": "Seleccionar",
        "field.default": "Por defecto",
        "field.model": "Modelo",
        "field.measurement": "Mediciones y envíos",
        "field.sensors": "Sensores",
        "field.alerts": "Alertas",
        "field.interval_type": "Tipo de intervalo",
        "field.start_hour": "Hora de inicio",
        "field.minutes_between_measures": "Minutos entre medidas",
        "field.number_to_send": "Número para enviar",
        "field.publication_interval": "Intervalo de publicación",
        "field.collected_measures": "Número de medidas recopiladas",
        "field.minutes_between_measures_fl": "Minutos entre medidas FL",

        // Mensajes
        "message.error.required": "El nombre y el modelo son obligatorios.",
        "message.success.title": "Operación realizada con éxito",
        "message.success.text": "Se han guardado los cambios.",
        "message.error.title": "Error en el servicio de guardar",
        "message.error.text": "No se han podido guardar los datos",
        "message.delete.error.text": "No se han podido borrar los datos",
        "message.server.title": "Error en el servidor",
        "message.server.text": "Avise al administrador.",
        "message.missing.fields": "Faltan campos",
        "message.all.fields.required": "Todos los campos son obligatorios.",
        "message.value.range": "El valor tiene que estar entre {min}-{max}",
        "message.register.delete.success":
            "Los registros seleccionados se han eliminado correctamente",
        // Botones
        "button.accept": "Aceptar",
        "button.save": "Guardar",
        "button.cancel": "Cancelar",
        "button.add": "Añadir",
        "button.delete": "Eliminar",

        // Columnas de tabla
        "table.name": "Nombre",
        "table.default": "Defecto",
        "table.model": "Modelo",
        "table.measurement": "Medición & Envíos",
        "table.sensors": "Sensores",
        "table.alerts": "Alertas",

        // Secciones y etiquetas
        "labels.config-profile": "Perfil de configuración",
        "labels.config-group": "Grupo de configuración",
    },
    en: {
        // Títulos
        "preview.title": "Profile Group",
        "preview.title.sensor": "Sensor configuration",

        "preview.add": "Add",
        "preview.add.ship": "Add new mode",
        "preview.saved": "Saved",
        "preview.saved.success": "Successfully saved.",
        "preview.error": "Service error",
        "preview.error.admin": "Contact administrator",

        // Pestañas
        "tab.data": "Data",
        "tab.general": "General",
        "tab.sensors": "Sensors",
        "tab.alerts": "Alerts",
        "tab.shipping": "Shipping",

        // Campos
        "field.name": "Name",
        "field.description": "Description",
        "field.select": "Select",
        "field.default": "Default",
        "field.model": "Model",
        "field.measurement": "Measurements and Shipping",
        "field.sensors": "Sensors",
        "field.alerts": "Alerts",
        "field.interval_type": "Interval Type",
        "field.start_hour": "Start Hour",
        "field.minutes_between_measures": "Minutes Between Measures",
        "field.number_to_send": "Number to Send",
        "field.publication_interval": "Publication Interval",
        "field.collected_measures": "Number of Collected Measures",
        "field.minutes_between_measures_fl": "Minutes Between Measures FL",

        // Mensajes
        "message.error.required": "Name and model are required.",
        "message.success.title": "Operation completed successfully",
        "message.success.text": "Changes have been saved.",
        "message.error.title": "Error in save service",
        "message.error.text": "Data could not be saved",
        "message.delete.error.text": "Data could not be deleted",
        "message.server.title": "Server error",
        "message.server.text": "Contact the administrator.",
        "message.missing.fields": "Missing fields",
        "message.all.fields.required": "All fields are required.",
        "message.value.range": "Value must be between {min}-{max}",
        "message.register.delete.success":
            "The selected records have been successfully deleted",

        // Botones
        "button.accept": "Accept",
        "button.save": "Save",
        "button.cancel": "Cancel",
        "button.add": "Add",
        "button.delete": "Delete",

        // Columnas de tabla
        "table.name": "Name",
        "table.default": "Default",
        "table.model": "Model",
        "table.measurement": "Measurement & Shipping",
        "table.sensors": "Sensors",
        "table.alerts": "Alerts",

        // Secciones y etiquetas
        "labels.config-profile": "Configuration Profile",
        "labels.config-group": "Configuration Group",
    },
};
